import React from "react";
import styled from "styled-components";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Switch, Route } from "react-router-dom";

import Header from "../header";
import Jurisdictions from "../jurisdictions";
import Signing from "../signing";
import Error from "../common/Error";
import Main from "../main";
import Info from "../info";
import OAuthCallback from "../auth/callback";

const StyledMain = styled.main`
  max-width: 1180px;
  min-height: calc(100vh - 60px);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function App() {
  return (
    <>
      <CssBaseline />
      <Header />
      <StyledMain>
        <Switch>
          <Route
            path="/short/:code/inactive"
            render={() => (
              <Error message="The link you are attempting to access has been disabled. Our records indicate that a new link has been sent in its place." />
            )}
          />
          <Route
            path="/short/:code"
            component={({ match }) => {
              window.location.replace(
                `${window.env.FORMS_API_URL}/short/${match.params.code}`
              );
              return null;
            }}
          />
          <Route
            exact
            path="/signing/:signingId"
            render={({ match }) => (
              <Signing match={match} key={match.params.signingId} />
            )}
          />
          <Route path="/oauth" render={() => <OAuthCallback />} />
          <Route
            exact
            path="/:productGuidOrCompanyId"
            render={({ match }) => (
              <Jurisdictions
                match={match}
                key={match.params.productGuidOrCompanyId}
              />
            )}
          />
          <Route
            path="/:productGuidOrCompanyId/:jurId"
            render={({ history, match }) => (
              <Info
                match={match}
                history={history}
                key={match.params.productGuidOrCompanyId}
              />
            )}
          />
          <Route render={() => <Main />} />
        </Switch>
      </StyledMain>
    </>
  );
}

export default App;
